import urlUtils from '../../utils/urlUtils';
import * as marketCountryMapping from './marketCountryMapping';
import * as marketNames from './marketNames';

export default class ConfigClient {
    constructor(marketConfigsList) {
        this.marketConfigsList = marketConfigsList;
    }

    getMarketConfigImport(market) {
        const currentUrl = urlUtils.getOriginLocation();
        const href = market ? urlUtils.join(currentUrl, market.toLowerCase()) : urlUtils.getCurrentLocation();
        const marketConfigImport = this.marketConfigsList.find(({urls}) => urls.some((url) => href.startsWith(url)));

        return marketConfigImport;
    }

    async getMarketConfig(market) {
        const marketConfigImport = this.getMarketConfigImport(market);
        const configResponse = await marketConfigImport?.configImport();

        return configResponse?.default;
    }

    async getConfig() {
        const market = await marketCountryMapping.getMarketByCountryCode();

        const marketConfig = await this.getMarketConfig(market);
        const isMarketInitialized = !!marketConfig;
        const isMarketDetected = market !== null;

        return {...marketConfig, isMarketInitialized: isMarketInitialized && isMarketDetected, isMarketDetected};
    }
}

export const getMarketConfigList = (handler) => {
    const marketConfigsList = Object.entries(marketNames)
        .reverse()
        // eslint-disable-next-line no-unused-vars
        .map(([key, marketName]) => handler(marketName));

    return marketConfigsList;
};
